import $ from 'jquery';

$(document).ready(function () {
  acfSvgBlock();
});

function acfSvgBlock() {
  $('.js-acf-svg').each(function () {});
}
